import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontBarlowSemiCondensed } from "@product/scmp-sdk";

import { DrawerCard, DrawerCardHeader, DrawerCardTitle } from "~/components/common/drawer/styles";

import { DynamicContentShareWidget, DynamicDrawer } from "./dynamics";

export const StyledDynamicDrawer = styled(DynamicDrawer)`
  ${DrawerCard} {
    position: relative;

    inline-size: 100%;
    padding-block: 20px 32px;
    padding-inline: 20px;
  }

  ${DrawerCardHeader} {
    margin-block-end: 25px;
  }

  ${DrawerCardTitle} {
    inline-size: 100%;

    font-weight: unset;
    font-size: 19px;
    line-height: 23px;
    text-align: center;
  }
`;

export type ShareWidgetProps = {
  $variant?: "default" | "magazines-style";
};
export const StyledDynamicContentShareWidget = styled(DynamicContentShareWidget)<ShareWidgetProps>`
  display: grid;
  grid-template-columns: repeat(4, 50px);
  gap: 24px 37px;
  justify-content: center;
  justify-items: center;

  ${props =>
    props.$variant === "magazines-style" &&
    css`
      button {
        > :first-child {
          background-color: #ffffff;

          outline: 1px solid #222222;

          svg {
            path {
              fill: #222222;
            }
          }
        }

        > :last-child {
          color: #222222;
          font-family: ${fontBarlowSemiCondensed};
        }
      }
    `}
`;
